import { FaLinkedin, FaTwitter, FaGithub } from "react-icons/fa";
import { motion } from "framer-motion";

const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
};

export default function Footer() {
  return (
    <footer className="bg-[#0f111a] text-gray-300 py-16 px-6 md:px-16">
      <motion.div
        className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {/* Logo and description */}
        <motion.div variants={fadeInUp} className="text-center md:text-left md:col-span-1">
          {/* Logo */}
          <div className="mb-0"> {/* No gap below logo */}
            <img
              src="/logo_02_01.png" // Your logo in public folder
              alt="BasoreTech Logo"
              className="h-24 md:h-28 mx-auto md:mx-0 w-auto" // Bigger logo
            />
          </div>
          {/* Description */}
<p className="text-gray-400 leading-tight text-xs md:text-sm">
  Basore Technologies delivers enterprise-grade IT solutions in system administration,
  network security, cloud management, and infrastructure automation.
</p>

        </motion.div>

        {/* Quick Links */}
        <motion.div variants={fadeInUp} className="text-center md:text-left">
          <h4 className="font-semibold text-white mb-4">Company</h4>
          <ul className="space-y-2">
            <li>
              <a href="#about" className="hover:text-[#00fff7] transition-colors duration-200">
                About
              </a>
            </li>
            <li>
              <a href="#services" className="hover:text-[#00fff7] transition-colors duration-200">
                Services
              </a>
            </li>
            <li>
              <a href="#case-studies" className="hover:text-[#00fff7] transition-colors duration-200">
                Case Studies
              </a>
            </li>
            <li>
              <a href="#contact" className="hover:text-[#00fff7] transition-colors duration-200">
                Contact
              </a>
            </li>
          </ul>
        </motion.div>

        {/* Social Links */}
        <motion.div variants={fadeInUp} className="text-center md:text-left">
          <h4 className="font-semibold text-white mb-4">Follow Us</h4>
          <div className="flex justify-center md:justify-start gap-6">
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00fff7] transition-transform transform hover:scale-110 duration-200"
              aria-label="LinkedIn"
            >
              <FaLinkedin size={26} />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00fff7] transition-transform transform hover:scale-110 duration-200"
              aria-label="Twitter"
            >
              <FaTwitter size={26} />
            </a>
            <a
              href="https://github.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#00fff7] transition-transform transform hover:scale-110 duration-200"
              aria-label="GitHub"
            >
              <FaGithub size={26} />
            </a>
          </div>
        </motion.div>

        {/* Newsletter / Email Subscription */}
        <motion.div variants={fadeInUp} className="text-center md:text-left">
          <h4 className="font-semibold text-white mb-4">Subscribe</h4>
          <p className="text-gray-400 mb-4">Get updates on our latest IT solutions and services.</p>
          <form className="flex flex-col sm:flex-row gap-3">
            <input
              type="email"
              placeholder="Your email"
              className="px-4 py-2 rounded-md text-black w-full sm:w-auto flex-1 focus:outline-none
                         transition-transform duration-200 hover:scale-105 focus:scale-105"
            />
            <button
              type="submit"
              className="bg-gradient-to-r from-[#00fff7] to-[#0077ff] text-black font-semibold 
                         px-8 py-3 rounded-full shadow-xl hover:scale-105 transition-transform duration-300"
            >
              Subscribe
            </button>
          </form>
        </motion.div>
      </motion.div>

      {/* Copyright */}
      <motion.div
        className="mt-12 border-t border-gray-800 pt-6 text-center text-gray-500 text-sm"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1, transition: { duration: 0.8 } }}
        viewport={{ once: true, amount: 0.2 }}
      >
        © {new Date().getFullYear()} Basore Technologies. All rights reserved.
      </motion.div>
    </footer>
  );
}
